import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {NavLink} from 'react-router-dom';
import {Tag, theme, Typography} from 'antd';
import {showDatesRange} from 'helpers/utils';
import {AppRoutePaths} from 'routing/Routes';
import {getStatusColor} from 'views/serviceActions/utils/ServicesUtils';
import {ServiceTaskDto} from '../../../../PRMGApiClient';

const {Text} = Typography;

export const TaskContainer: React.FC<{task: ServiceTaskDto}> = ({task}) => {
  const {t} = useTranslation();
  const {id, name, assignee, startDateTime: startDate, endDateTime: endDate, status, description} = task;
  const {token} = theme.useToken();

  const date = useMemo(() => {
    return showDatesRange(startDate, endDate);
  }, [startDate, endDate]);

  return (
    <NavLink to={AppRoutePaths.tasks.url + `/${id}`}>
      <div
        className="flex flex-col gap-2 p-2 border w-full hover:shadow-lg hover:scale-125 hover:cursor-pointer"
        style={{borderColor: token[getStatusColor(status)], borderRadius: token.borderRadiusLG}}
      >
        <div className="flex flex justify-between">
          <Text>{name}</Text>

          <Tag color={getStatusColor(status)} className="mr-0">
            {status}
          </Tag>
        </div>
        {description && <Text type="secondary">{description}</Text>}
        <Text>{date}</Text>
        <Typography>
          {t('Assigned to: ')}
          <Text strong>
            {assignee?.firstName} {assignee?.lastName}
          </Text>
        </Typography>
      </div>
    </NavLink>
  );
};
